/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Benefit_Support_TitleInputs */

const en_business_benefit_support_title = /** @type {(inputs: Business_Benefit_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const es_business_benefit_support_title = /** @type {(inputs: Business_Benefit_Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Business_Benefit_Support_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_benefit_support_title = /** @type {((inputs?: Business_Benefit_Support_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Benefit_Support_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_benefit_support_title(inputs)
	return en_business_benefit_support_title(inputs)
});